import { HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiResponse } from '../../../core/models';
import { BaseApiService } from '../../../core/services/base-api.service';
import {
  SelectableClientAssignmentForCartDTO,
  SelectableClientAssignmentsListDTO,
} from '../../models/shared.model';

@Injectable({
  providedIn: 'root',
})
export class SelectableClientAssignmentsHttpRepository
  extends BaseApiService
{
  private readonly controllerUrl = '/ClientAssignment/';

  public list(): Observable<
    HttpResponse<ApiResponse<SelectableClientAssignmentsListDTO>>
  > {
    return this.http.get<ApiResponse<SelectableClientAssignmentsListDTO>>(
      `${this.baseUrl}${this.controllerUrl}selectable-client-assignments`,
      { observe: 'response' }
    );
  }

  public listForCart(): Observable<
    HttpResponse<ApiResponse<SelectableClientAssignmentForCartDTO[]>>
  > {
    return this.http.get<ApiResponse<SelectableClientAssignmentForCartDTO[]>>(
      `${this.baseUrl}${this.controllerUrl}selectable-client-assignments-for-cart`,
      { observe: 'response' }
    );
  }
}
